import { AddTrainingEventSubscriptionRequest } from './add.training.event.subscription.request';

export class UpdateTrainingEventSubscriptionRequest extends AddTrainingEventSubscriptionRequest {
    TrainingEventSubscriptionID: number;
}

export class UpdateTrainingEventSubscriptionRequestArray extends Array<UpdateTrainingEventSubscriptionRequest> {

    constructor(...items: UpdateTrainingEventSubscriptionRequest[]) {
        super(...items);
        Object.setPrototypeOf(this, UpdateTrainingEventSubscriptionRequestArray.prototype);
    }
}
